
import React, { useState } from "react";
import ProductList from "./components/ProductList";
import OrderForm from "./components/OrderForm";
import "./App.css";

function App() {
  const [selectedProduct, setSelectedProduct] = useState(null);

  return (
    <div className="app">
      <header className="header">
        <h1> Public API Order Form</h1>
      </header>
      {!selectedProduct ? (
        <ProductList onSelectProduct={setSelectedProduct} />
      ) : (
        <OrderForm product={selectedProduct}
         onBack={() => setSelectedProduct(null)}
          />
        
      )}
     
    </div>
  );
}

export default App;

